const buildBadgeStyle = (backgroundColor, borderColor, color) => ({
    backgroundColor,
    border: `1px solid ${borderColor}`,
    color,
})

const defaultBadgeStyle = buildBadgeStyle('#F8FAFC', '#CBD5E1', '#334155')

const regionBadgeStyles = {
    '1': buildBadgeStyle('#F1F5F9', '#CBD5E1', '#334155'),
    '2': buildBadgeStyle('#FEE2E2', '#FCA5A5', '#991B1B'),
    '3': buildBadgeStyle('#FFEDD5', '#FDBA74', '#9A3412'),
    '4': buildBadgeStyle('#FEF3C7', '#FCD34D', '#92400E'),
    '5': buildBadgeStyle('#ECFCCB', '#BEF264', '#3F6212'),
    '6': buildBadgeStyle('#DCFCE7', '#86EFAC', '#166534'),
    '7': buildBadgeStyle('#E0F2FE', '#7DD3FC', '#075985'),
    '8': buildBadgeStyle('#E0E7FF', '#A5B4FC', '#3730A3'),
    '9': buildBadgeStyle('#CCFBF1', '#5EEAD4', '#115E59'),
}

const rangoBadgeStyles = {
    PA: buildBadgeStyle('#FFE4E6', '#FDA4AF', '#9F1239'),
    MA: buildBadgeStyle('#DCFCE7', '#86EFAC', '#166534'),
    ML: buildBadgeStyle('#FEF3C7', '#FCD34D', '#92400E'),
    MO: buildBadgeStyle('#E0F2FE', '#7DD3FC', '#075985'),
    MOE: buildBadgeStyle('#E0E7FF', '#A5B4FC', '#3730A3'),
    MOED: buildBadgeStyle('#F1F5F9', '#CBD5E1', '#334155'),
}

const tipoIglesiaBadgeStyles = {
    autonoma: buildBadgeStyle('#DBEAFE', '#93C5FD', '#1D4ED8'),
    'en formacion': buildBadgeStyle('#FEF3C7', '#FCD34D', '#92400E'),
    anexo: buildBadgeStyle('#EDE9FE', '#C4B5FD', '#6D28D9'),
    'en tramite de afiliacion': buildBadgeStyle('#FCE7F3', '#F9A8D4', '#9D174D'),
    caduca: buildBadgeStyle('#FEE2E2', '#FCA5A5', '#991B1B'),
    'en tramite regional': buildBadgeStyle('#DCFCE7', '#86EFAC', '#166534'),
}

const balanceBadgeStyles = {
    si: buildBadgeStyle('#DCFCE7', '#86EFAC', '#166534'),
    no: buildBadgeStyle('#FEE2E2', '#FCA5A5', '#991B1B'),
}

const normalizeKey = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase()

export const getRegionBadgeStyle = (region) => {
    return regionBadgeStyles[String(region)] || defaultBadgeStyle
}

export const getRangoBadgeStyle = (rango) => {
    return rangoBadgeStyles[String(rango || '').toUpperCase()] || defaultBadgeStyle
}

export const getTipoIglesiaBadgeStyle = (tipo) => {
    return tipoIglesiaBadgeStyles[normalizeKey(tipo)] || defaultBadgeStyle
}

export const getBalanceBadgeStyle = (balance) => {
    return balanceBadgeStyles[normalizeKey(balance)] || defaultBadgeStyle
}

export const isBalancePresentado = (balance) => {
    return normalizeKey(balance) === 'si'
}